'use strict';

var React = require('react/addons');

var Immutable = require('immutable');

var SelectOne = require('./simple-choice');

var COUNTRIES = Immutable.fromJS(require('ofs/utils/countries'));

var countryChoices = COUNTRIES.map(function(country) {
  return {
    name: country.get('name') + ' (+' + country.get('phone_prefix') + ')',
    value: country.get('iso_alpha3')
  };
}).toJS();



var InternationalPhoneInput = React.createClass({
  getInitialState() {
    var value = this.props.value;

    if (value) {
      var [prefix, number] = value.split('|');
    }

    return {
      tempPrefix: prefix || null,
      tempNumber: number || null, 
    };
  },

  onPrefixChange(event) {
    var country = event.target.value;
    var number = this.state.tempNumber;
    var prefix = this.state.tempPrefix;

    var _prefix = COUNTRIES.find((c) => c.get('iso_alpha3') === country);

    if (_prefix) {
      prefix = _prefix.get('phone_prefix');
    }

    if (prefix && number) {
      this.props.onChange(`${ prefix }|${ number }`);
    } else {
      this.props.onChange(null);
    }

    this.setState({tempPrefix: prefix});
  },

  onNumberChange(event) {
    var number = event.target.value; 
    var prefix = this.state.tempPrefix; 

    if (prefix && number) {
      this.props.onChange(`${ prefix }|${ number }`);
    } else {
      this.props.onChange(null);
    }
    this.setState({tempNumber: number}); 
  },

  render: function() {
    var {placeholder, value} = this.props;
    var prefix = null;
    var number = null;

    if (value) {
      [prefix, number] = value.split('|');
    }

    return (
      <div className="ofs-Input__Wrapper">
        <input type="hidden" {...this.props} ref="input" value={value} />
        <div className="ofs-Input__Prefix">
          <SelectOne onChange={this.onPrefixChange} placeholder="--" options={countryChoices} value={prefix} className="bdd-enquire-modal-field-phone-country"/>
        </div>
        <div className="ofs-Input__Value">
          <input onChange={this.onNumberChange} type="tel" value={number} placeholder={placeholder} className="bdd-enquire-modal-field-phone-number"/>
        </div>
      </div>
    );
  }
});

module.exports = InternationalPhoneInput;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/forms/inputs/international-phone-input.jsx
 **/